import { render } from "./vue-image-compressor.vue?vue&type=template&id=e7cda402"
import script from "./vue-image-compressor.vue?vue&type=script&lang=js"
export * from "./vue-image-compressor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__